// organize-imports-ignore
import "src/globalThis";
import "@homebound/activesupport";
import { ApolloProvider } from "@apollo/client";
import { CacheProvider } from "@emotion/react";
import { CssReset } from "@homebound/beam";
import { configureAuth } from "@homebound/auth-components";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { amplifyConfig, createApolloClient, getStage } from "./context";
import { createQuietEmotionCache } from "src/utils/emotionCache";
import "@homebound/beam/index.css";

const stage = getStage();
const apolloClient = createApolloClient(stage);
configureAuth(amplifyConfig(stage));

const emotionCache = createQuietEmotionCache();

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <ApolloProvider client={apolloClient}>
    <CacheProvider value={emotionCache}>
      <BrowserRouter>
        <CssReset />
        <App />
      </BrowserRouter>
    </CacheProvider>
  </ApolloProvider>,
);
